<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-department-department-dialog-create
          v-if="$hasPermissionTo(['create departments'])" 
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Department's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in department name here"
          append-icon="search"
          label="Search Department"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredDepartments"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-department-department-dialog-edit
            v-if="$hasPermissionTo(['update departments'])"
            :department="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-department-department-dialog-delete
            v-if="$hasPermissionTo(['delete departments'])"
            :department="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-department-department-dialog-restore
            v-if="$hasPermissionTo(['restore departments'])"
            :department="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupDepartmentDepartmentDialogCreate: () => import('@/components/hris/setup/department/department/DialogCreate'),
      SetupDepartmentDepartmentDialogDelete: () => import('@/components/hris/setup/department/department/DialogDelete'),
      SetupDepartmentDepartmentDialogRestore: () => import('@/components/hris/setup/department/department/DialogRestore'),
      SetupDepartmentDepartmentDialogEdit: () => import('@/components/hris/setup/department/department/DialogEdit'),
    },
    data () {
      return {
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Departments',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        departments: [],
        trashedDepartments: [],
      }
    },
    computed: {
      filteredDepartments () {
        return this.statusFilter ? this.departments : this.trashedDepartments
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.hrisDepartments().list(),
          this.$api.hrisDepartments().listTrashed(),
        ]).then(([department, trashedDepartments]) => {
          this.departments = department.data
          this.trashedDepartments = trashedDepartments.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
